import React, { FunctionComponent } from "react";
import { ILayoutPageProps, Layout } from "./component";

export const LayoutContainer: FunctionComponent<ILayoutPageProps> = ({ onPlayFromYouTube }) => {
  return <Layout onPlayFromYouTube={onPlayFromYouTube} />;
};
